import styled from "styled-components";

export const Table = styled.table``

export const Td = styled.td`
  padding-top: 10px;
  text-align: center;
  background: #4b286d;
  color: #fff;
`;

export const Tr = styled.tr`
  border: 1px solid #e3e3e3;
`;

export const Th = styled.th`
  padding-top: 10px;
  /* text-align: center; */
  color: #fff;
`

export const TdImp = styled.td`
  border: 1px solid #e3e3e3;
  text-align: left;
  background: #f7f7f7;
  font-weight: 700;
  vertical-align: middle;
`;